<template>
  <div>
    <div class="table-title" style="margin-top:10px;">Doc Records</div>
    <table class="fixed-table">
      <tr style="height:0;border:0">
        <th style="width:60px;"></th>
        <th style="width:180px;"></th>
        <th style="width:130px;"></th>
        <th style="width:130px;"></th>
        <th style="width:40px;"></th>
        <th style="width:60px;"></th>
        <th style="width:130px;"></th>
        <th style="width:120px;"></th>
        <th style="width:60px;"></th>
        <th style="width:80px;"></th>
        <th></th>
      </tr>
      <tr>
        <th>
          &nbsp;
        </th>
        <th colspan="2" style="border-right:1px solid #000;">
          Product
        </th>
        <th colspan="4" style="border-right:1px solid #000;">
          Buyer
        </th>
        <th colspan="4">
          Vendor
        </th>
      </tr>
      <tr>
        <th>input time</th>
        <th>part number</th>
        <th style="border-right:1px solid #000;">description</th>
        <th>buyer</th>
        <th>qty</th>
        <th>cost(usd)</th>
        <th style="border-right:1px solid #000;">remark</th>
        <th>vendor</th>
        <th>price(usd)</th>
        <th>remark</th>
        <th>date</th>
      </tr>
      <tr v-for="item in docList" :key="item.id" :class="item.is_del === '1' ? 'row-red' : (item.is_special === '1' ? 'row-bg-yellow' : '')">
        <td>{{ item.oper_time | shortDate }}</td>
        <td :title="item.part_no"><el-button type="text" @click="$open(`/product/${item.product_id}/require`)">{{ item.part_no }}</el-button></td>
        <td :title="item.description" style="border-right:1px solid #000;">{{ item.description }}</td>
        <td :title="item.buyer">{{ item.buyer }}</td>
        <td>{{ item.qty }}</td>
        <td>{{ item.cost }}</td>
        <td style="border-right:1px solid #000;">{{ item.buyer_remark }}</td>
        <td :title="item.vendor">{{ item.vendor }}</td>
        <td>{{ item.price }}</td>
        <td :title="item.vendor_remark" v-if="item.is_del === '0'">{{ item.vendor_remark }}</td>
        <td :title="item.date" v-if="item.is_del === '0'">{{ item.date }}</td>
        <td colspan="2" v-else>deleting...</td>
      </tr>
    </table>
    <no-data :loading="loading" :list="docList"></no-data>
  </div>
</template>

<script>
import NoData from '@/components/NoData'
export default {
  components: {
    NoData
  },
  data () {
    return {
      company: {
        id: this.$route.params.id,
        name: ''
      },
      docList: [],
      loading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchDocList()
  },
  methods: {
    fetchCompany () {
      this.loading = true
      this.$http.get('/dbapi/company_list', {
        params: {
          id: this.$route.params.id
        }
      }).then(data => {
        this.loading = false
        if (data.list.length > 0) {
          this.company = data.list[0]
        }
      })
    },
    fetchDocList () {
      this.$http.get('/dbapi/product_doc_list?company_id=' + this.$route.params.id).then(data => {
        this.docList = data.list
      })
    }
  }
}
</script>
